import { Component, EventEmitter, Inject, OnInit, Output, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { TruckingRouteDto } from '@shared/src/dtos/trucking/TruckingRouteDto';
import { TruckingRouteExpandDto } from '@shared/src/dtos/trucking/TruckingRouteExpandDto';
import { TruckingController } from '@shared/src/controllers/trucking/trucking.controller';
import { TruckingShipmentPackageDto } from '@shared/src/dtos/trucking/TruckingShipmentPackageDto';
import { DragDropService } from '@shared/src/services/dragdrop/DragDropService';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { ParticipantDto } from '@shared/src/dtos/chat/participant/ParticipantDto';
import { ChatParticipantTypes } from '@shared/src/enums/ChatParticipantTypes';
import { ChatController } from '@shared/src/public-api';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { TruckingRouteExecuteActionDto } from '@shared/src/dtos/trucking/TruckingRouteExecuteActionDto';
import { TruckingRouteActions } from '@shared/src/enums/TruckingRouteActions';
import { TruckingRouteActionConfirmDto } from '@shared/src/dtos/trucking/TruckingRouteActionConfirmDto';


@Component({
	selector: 'shared-trucking-route-panel',
	templateUrl: './shared.trucking.route.panel.component.html',
	styleUrls: ['./shared.trucking.route.panel.component.scss']
})
export class SharedTruckingRoutePanelComponent implements OnInit {

	public useIonic: boolean = false;
	public iReadonly: boolean = false;

	public searchTextGroup: string = "";
	public filterMetadata: any = {};


	@Output() clickBack = new EventEmitter<boolean>();
	@Output() refreshRoute = new EventEmitter<TruckingRouteExpandDto>();

	constructor(
		public truckingController: TruckingController,
		public chatController: ChatController,
		public fb: FormBuilder,
		@Inject('HomeController') protected homeController: HomeController,
		@Inject("SecurityController") protected securityController: SecurityController,
		@Inject("AlertService") protected alertService: AlertService) {
		this.securityController.getStoredUserDto().subscribe(data => {
			this.iReadonly = data.isReadOnly;
		});

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}


	ngOnInit(): void {

	}

	public _openPanel: boolean = false;
	@Input()
	public get openPanel(): boolean {
		return this._openPanel;
	}
	public set openPanel(value: boolean) {
		if (this._openPanel === value)
			return;
		this._openPanel = value;
	}

	public _selectedRouteExpand: TruckingRouteExpandDto;
	@Input()
	public get selectedRouteExpand(): TruckingRouteExpandDto {
		return this._selectedRouteExpand;
	}
	public set selectedRouteExpand(value: TruckingRouteExpandDto) {
		if (this._selectedRouteExpand === value)
			return;
		this._selectedRouteExpand = value;
		this.loadOptions()
		this.loadActions();
	}


	public options: OptionsStripDto;
	public actualOptionId: string = "LOAD";
	public loadOptions() {
		let result = new OptionsStripDto();
		if (this.selectedRouteExpand != null) {
			result.add(OptionDto.build("LOAD", "TRUCKING.ROUTE.OPCIONS.LOAD.CAPTION", "TRUCKING.ROUTE.OPCIONS.LOAD.HELP", "", 1, -1, 1, true, false));
			result.add(OptionDto.build("ROUTE", "TRUCKING.ROUTE.OPCIONS.ROUTE.CAPTION", "TRUCKING.ROUTE.OPCIONS.ROUTE.HELP", "", 2, -1, 1, false, false));
			result.add(OptionDto.build("PARTNERS", "TRUCKING.ROUTE.OPCIONS.PARTNERS.CAPTION", "TRUCKING.ROUTE.OPCIONS.PARTNERS.HELP", "", 3, -1, 1, false, false));
			result.add(OptionDto.build("DRIVER", "TRUCKING.ROUTE.OPCIONS.DRIVER.CAPTION", "TRUCKING.ROUTE.OPCIONS.DRIVER.HELP", "", 4, -1, 1, false, false));
			result.add(OptionDto.build("CHAT", "TRUCKING.ROUTE.OPCIONS.CHAT.CAPTION", "TRUCKING.ROUTE.OPCIONS.CHAT.HELP", "", 5, -1, 1, false, false));
			this.actualOptionId = result.getActualSelected().optionId;
		} else {
			this.actualOptionId = "LOAD";
		}
		this.options = result;
	}

	public actions: ActionsStripDto = new ActionsStripDto();
	loadActions() {
		let tactions: ActionsStripDto = new ActionsStripDto();

		if (this.selectedRouteExpand != null) {

			if (this.selectedRouteExpand.isTrucked) {

				if (!this.selectedRouteExpand.truckingConfirmed) {
					tactions.add(ActionDto.buildBase("CONFIRMEDROUTE", "TRUCKING.ROUTE.ACTION.CONFIRMEDROUTE.CAPTION", "TRUCKING.ROUTE.ACTION.CONFIRMEDROUTE.HELP", "fa-check-circle", 1, 0, 1, "", "action-ADD"));
					tactions.add(ActionDto.build("REMOVEROUTE", "TRUCKING.ROUTE.ACTION.REMOVEROUTE.CAPTION", "TRUCKING.ROUTE.ACTION.REMOVEROUTE.HELP", "", 2, -1, -1, ""));
				} else
					tactions.add(ActionDto.build("DESCONFIRMED", "TRUCKING.ROUTE.ACTION.DESCONFIRMEDROUTE.CAPTION", "TRUCKING.ROUTE.ACTION.DESCONFIRMEDROUTE.HELP", "", 3, -1, -1, ""));

			}
		}
		this.actions = tactions;
	}

	public askingAction: boolean = false;
	public truckingAction: TruckingRouteActionConfirmDto;
	onClickPreAction(action: ActionDto) {

		if (action != null) {
			if (action.actionId == "CONFIRMEDROUTE") {
				this.onClickAction(action);
			} else if (action.actionId == "REMOVEROUTE") {
				this.truckingAction = TruckingRouteActionConfirmDto.REMOVEROUTE(action);
				this.askingAction = true;
			} else if (action.actionId == "DESCONFIRMED") {
				this.truckingAction = TruckingRouteActionConfirmDto.DESCONFIRMEDTRUCKING(action);
				this.askingAction = true;
			}
		}

	}


	onClickAction(action: ActionDto) {

		this.askingAction = false;

		if (this.selectedRouteExpand == null)
			return;

		if (action != null) {
			if (action.actionId == "CONFIRMEDROUTE") {
				this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.ConfirmedRoute, this.selectedRouteExpand.routeId, 0, 0)).subscribe(data => {
					if (data)
						this.onActionRouteExpand("CONFIRMEDROUTE");
				});
			} else if (action.actionId == "REMOVEROUTE") {
				this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.RemoveRoute, this.selectedRouteExpand.routeId, 0, 0)).subscribe(data => {
					if (data)
						this.onActionRouteExpand("REMOVEROUTE");
				});
			} else if (action.actionId == "DESCONFIRMED") {
				this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.DesconfirmedRoute, this.selectedRouteExpand.routeId, 0, 0)).subscribe(data => {
					if (data)
						this.onActionRouteExpand("DESCONFIRMED");
				});
			}
		}
	}

	public forcedOwnerParticipant: ParticipantDto;
	onClickOption(option: OptionDto) {
		this.actualOptionId = option.optionId;
		if (option && option.optionId === "CHAT") {
			this.forcedOwnerParticipant = ParticipantDto.buildByParams(this.selectedRouteExpand.routeId, ChatParticipantTypes.Route);
		}
	}
	clickParticipant(participant: ParticipantDto) {
		this.chatController.onClickParticipant(participant);
	}

	onClickBack(event) {
		this.clickBack.next(true);
	}

	//////////////////////////////// DRAG & DROP ///////////////////////////////////////////

	dragover(event: DragEvent) {
		event.preventDefault();
		if (DragDropService.isDraggedObjectHardmanType(event)) {
			event.dataTransfer.dropEffect = 'copy';
		} else {
			event.dataTransfer.dropEffect = 'none';
		}
	}

	dropAtZone(event: DragEvent) {
		if (DragDropService.isDraggedObjectHardmanType(event)) {
			let draggedobject: any = DragDropService.extractDraggedObjectHardmanType(event);
			if (draggedobject != null) {
				this.onPackageAdd(draggedobject);
				return;
			}
		}

	}

	////////////////////////////////////////////////////////////////

	public onPackageAdd(spackage: TruckingShipmentPackageDto) {
		if (this._selectedRouteExpand == null || spackage == null)
			return;

		if (this._selectedRouteExpand.packages == null)
			this._selectedRouteExpand.packages = new Array();

		let exists = false;
		this._selectedRouteExpand.packages.forEach(element => {
			if (element.packageId == spackage.packageId)
				exists = true;
		});

		if (exists)
			return;

		this._selectedRouteExpand.packages.push(spackage);

		this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.AddPackage, this.selectedRouteExpand.routeId, 0, spackage.packageId)).subscribe(data => {
			if (!data)
				this.onPackageRemove(spackage);
			else {
				this.truckingController.refreshShipmentList$.next(true);
				this.truckingController.shipmentChanged$.next(spackage.shipmentId);
				this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
			}
		});

	}

	onActionRouteExpand(action: string) {
		this.truckingController.refreshShipmentList$.next(true);
		this.truckingController.refreshRouteList$.next(true);
		if (action != 'REMOVEROUTE') {
			if (this.selectedRouteExpand)
				this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
			this.refreshRoute.next(this.selectedRouteExpand);
		} else {
			this.refreshRoute.next(null);
		}
	}

	onPackageRemove(spackage: TruckingShipmentPackageDto) {
		if (spackage == null)
			return;
		let newlist: Array<TruckingShipmentPackageDto> = [];
		this._selectedRouteExpand.packages.forEach(element => {
			if (element.packageId != spackage.packageId)
				newlist.push(element);
		});
		this._selectedRouteExpand.packages = newlist;
	}

}
